import { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";

import { useLazyGetUserByIdQuery } from "@/redux/service";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import UserProfileContainer from "@/features/users/profile/components/UserProfileContainer";

const UserProfile = () => {
  const { userId } = useParams();
  const [getUserById, userResponse] = useLazyGetUserByIdQuery();

  useEffect(() => {
    if (userId) {
      getUserById(userId);
    }
  }, [userId]);

  if (userResponse.isLoading) return <BaseSpinner />;

  if (userResponse.isError) return <Navigate to="/users" />;

  return (
    userResponse.isSuccess && <UserProfileContainer user={userResponse.data} />
  );
};

export default UserProfile;
